import api from "../api";

const api_type = 'v1'

export const ConfigSpendRebate = params => { return api.post(api_type+`/spend_rebate/config`, params) }
export const EditConfigSpendRebate = params => { return api.post(api_type+`/spend_rebate/edit_config`, params) }
export const DeleteConfigSpendRebate = params => { return api.post(api_type+`/spend_rebate/delete_config`, params) }
export const GetConfigSpendRebate = params => { return api.post(api_type+`/spend_rebate/get_config`, params) }
export const CloseAdvertiser = params => { return api.post(api_type+`/spend_rebate/close_advertiser`, params) }
export const GetSpendRebate = params => { return api.post(api_type+`/spend_rebate/get_rebate`, params) }
export const GetAccountAdvertiser = params => { return api.post(api_type+`/spend_rebate/get_account_advertiser`, params) }





// WEBPACK FOOTER //
// ./src/api/v1/spend_rebate_api.js